import { IContact, PlatformRole } from '@interfaces/chat/chatI';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
export const sessionSocketChatSlice = createSlice({
    name: 'sessionSocketChat',
    // initial session state as SessionDataI interface model
    initialState: {
        email: '',
        id: '',
        isDependent: false,
        name: ``,
        username: '',
        status: 'disconnected',
        platformRole: PlatformRole.PR 
    } as IContact,
    reducers: {
        setSessionSocket: (state, action: PayloadAction<IContact>) => {
            state.email = action.payload.email;
            state.id = action.payload.id;
            state.isDependent = action.payload.isDependent;
            state.name = action.payload.name ;
            state.username = action.payload.username;
            // state.status = action.payload.status;
            state.platformRole = action.payload.platformRole;
        },
        cleanSessionSocket: (state) => {
            state.email = '';
            state.id = '';
            state.isDependent = false;
            state.name = '';
            state.username = '';
            // state.status = undefined;
            state.platformRole = PlatformRole.PR;
            
        },
    },
});

export const { setSessionSocket, cleanSessionSocket } = sessionSocketChatSlice.actions;
export default sessionSocketChatSlice.reducer;
